import { shiftDate } from "./format";

export const presetPeriods = ["today", "yesterday", "week", "lastWeek", "month", "lastMonth"] as const;
export type PresetPeriod = (typeof presetPeriods)[number];

/** Longest report period, as on the server. */
export const MAX_REPORT_DAYS = 93;

/** [from, to] of a preset period, as YYYY-MM-DD in the viewer's zone. */
export function periodRange(period: PresetPeriod, today: string): [string, string] {
  const weekday = (new Date(`${today}T12:00:00Z`).getUTCDay() + 6) % 7; // Monday = 0
  const monday = shiftDate(today, -weekday);
  const monthStart = `${today.slice(0, 8)}01`;
  switch (period) {
    case "today":
      return [today, today];
    case "yesterday":
      return [shiftDate(today, -1), shiftDate(today, -1)];
    case "week":
      return [monday, today];
    case "lastWeek":
      return [shiftDate(monday, -7), shiftDate(monday, -1)];
    case "month":
      return [monthStart, today];
    case "lastMonth": {
      const lastDay = shiftDate(monthStart, -1);
      return [`${lastDay.slice(0, 8)}01`, lastDay];
    }
  }
}

/** Whole days from one date to another. */
export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T12:00:00Z`) - Date.parse(`${from}T12:00:00Z`)) / 86_400_000);
}

/** The period is ordered and not longer than the server allows. */
export function validPeriod(from: string, to: string): boolean {
  return from <= to && daysBetween(from, to) < MAX_REPORT_DAYS;
}
